export default __webpack_public_path__ + "static/media/fireflink-finder.7879d213.svg";